module.exports = __webpack_public_path__ + "static/media/opinion_simple.1c7a479a.png";